/* KIAURA: one accordion open at a time.
   Symmetry's <details-disclosure> lets every disclosure open independently, so
   a product page can end up with four panels stacked open. Three Nails, ASRV
   and Haus all behave as a true accordion, and this matches that.

   Grouped by nearest .shopify-section so a product page's accordions don't
   close a footer or FAQ section's, and vice versa.

   `toggle` does not bubble, hence the capture-phase listener on document. That
   also means this needs no per-element init and keeps working after an AJAX
   section swap. */
(function () {
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.disclosure')) return;
    if (!d.open) return;

    var group = d.closest('.shopify-section') || document;
    group.querySelectorAll('details.disclosure[open]').forEach(function (other) {
      if (other !== d) other.open = false;
    });
  }, true);
})();
